/**
 * bl_custom.js
 * ---------------------------------------------------------------------------
 * Boolland custom front-end behaviour that doesn't belong in theme.js.
 * Loaded (deferred) from layout/theme.liquid after js-variables, so
 * window.themeVariables is already defined when this runs.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  /**
   * Silence the add-to-cart confirmation popup on specific pages.
   *
   * theme.js only shows the popup / opens the drawer / redirects when
   * cartType is "popover" / "drawer" / "page". Setting it to anything else
   * makes the add silent (the cart still updates via the cart:change event).
   * We only override the in-memory value, so the store-wide Cart setting and
   * every other page are unaffected.
   */
  var SILENT_CART_PATHS = ['/pages/buy-more-save-more'];

  var path = window.location.pathname;
  var isSilentCartPage = SILENT_CART_PATHS.some(function (p) {
    return path.indexOf(p) !== -1; // indexOf handles locale prefixes e.g. /en/pages/...
  });

  if (isSilentCartPage && window.themeVariables && window.themeVariables.settings) {
    window.themeVariables.settings.cartType = 'none';
  }
})();
